import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeHighlight from 'rehype-highlight'
import rehypeSlug from 'rehype-slug'
import rehypeAutolinkHeadings from 'rehype-autolink-headings'
import { CopyablePre } from './CopyablePre'
import { ExternalLink } from './ExternalLink'
import { H1, H2, H3 } from './MarkdownHeadings'
import { ResponsiveTable } from './ResponsiveTable'
import { cn } from '@/lib/cn'

// highlight.js theme — minimal, uses CSS variables where possible.
// We inject a thin override in the layout CSS instead of importing
// a full highlight.js theme bundle.

interface MarkdownRendererProps {
  body: string
  className?: string
}

/**
 * Renders a raw markdown string with:
 *  - GitHub-flavored markdown (tables, strikethrough, task lists)
 *  - Syntax highlighting via rehype-highlight (highlight.js)
 *  - Heading IDs (rehype-slug) + anchor links (rehype-autolink-headings)
 *  - Copy-to-clipboard <pre> blocks
 *  - Horizontally scrollable tables
 *  - Safe external link handling (rel=noopener)
 */
export function MarkdownRenderer({ body, className }: MarkdownRendererProps) {
  return (
    <div className={cn('prose-onboarding', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[
          rehypeHighlight,
          rehypeSlug,
          [rehypeAutolinkHeadings, { behavior: 'wrap' }],
        ]}
        components={{
            pre: CopyablePre,
          a: ExternalLink,
          h1: H1,
          h2: H2,
          h3: H3,
          // Wrap tables for horizontal scroll on narrow viewports
          table: ResponsiveTable,
          // thead/tbody/tr/th/td: light styling via prose-onboarding CSS
        }}
      >
        {body}
      </ReactMarkdown>
    </div>
  )
}
